import { observer } from "mobx-react-lite";
import React from "react";
import { useStores } from "@client/store";
import { Modal } from "@src/common/components/Modal/Modal";
import { Icon } from "@ugc-ui/lego";
import { ModalContentWrapper } from "@src/common/components/Modal/ModalTemplate/ModalContentWrapper/ModalContentWrapper";
import { ProfileMenuSharedContent } from "../ProfileMenuSharedContent/ProfileMenuSharedContent";
import {
  TitleContainer,
  TypographyTitle,
} from "./FullScreenModalProfileMenu.styled";

export const FullScreenModalProfileMenu = observer(() => {
  const {
    client: {
      fullScreenProfileDialogStore: { isOpen, closeDialog: handleCloseDialog },
    },
  } = useStores();

  return (
    <Modal isOpen={isOpen} fullScreen>
      <ModalContentWrapper fullScreen>
        <TitleContainer alignItems="center" onClick={handleCloseDialog}>
          <Icon icon="chevron-left" />

          <TypographyTitle type="subtitle2" color="default">
            Настройки аккаунта
          </TypographyTitle>
        </TitleContainer>

        <ProfileMenuSharedContent />
      </ModalContentWrapper>
    </Modal>
  );
});
